export const createDefaultEquipmentCategorySpecSchema = () => {
  const rows = Array.from({ length: 8 }, (_, index) => ({
    id: `spec_${index + 1}`,
    label: `Spec${index + 1}`,
    type: "text",
    description: "",
    unit: "",
    options: "",
    required: false,
  }));
  const columns = [
    {
      id: "value",
      label: "Value",
      type: "text",
      description: "",
      options: "",
      required: false,
      width: 180,
    },
  ];
  const cells = {};
  rows.forEach((row) => {
    cells[`${row.id}:value`] = { type: "text" };
  });
  return { rows, columns, cells, values: {} };
};

const parseOptions = (raw) => {
  if (Array.isArray(raw)) {
    return raw.map((x) => String(x).trim()).filter(Boolean);
  }
  if (raw == null) return [];
  return String(raw)
    .split(",")
    .map((x) => x.trim())
    .filter(Boolean);
};

export const normalizeSpecSchema = (schema) => {
  if (!schema) return { rows: [], columns: [], cells: {}, values: {} };
  if (typeof schema === "string") {
    try {
      return normalizeSpecSchema(JSON.parse(schema));
    } catch {
      return { rows: [], columns: [], cells: {}, values: {} };
    }
  }
  if (!schema || typeof schema !== "object" || Array.isArray(schema)) {
    return { rows: [], columns: [], cells: {}, values: {} };
  }
  return {
    rows: Array.isArray(schema.rows) ? schema.rows : [],
    columns: Array.isArray(schema.columns) ? schema.columns : [],
    cells: schema.cells && typeof schema.cells === "object" && !Array.isArray(schema.cells)
      ? schema.cells
      : {},
    values: schema.values && typeof schema.values === "object" && !Array.isArray(schema.values)
      ? schema.values
      : {},
  };
};

export const getSpecFieldsFromSchema = (schema) => {
  const normalized = normalizeSpecSchema(schema);
  const inputColumns = normalized.columns.filter((col) => {
    const type = String(col?.type || "text").toLowerCase();
    return type !== "label" && type !== "na";
  });
  const valueColumn = inputColumns[0] || { id: "value", type: "text" };

  return normalized.rows
    .filter((row) => row && row.id && row.label)
    .map((row) => {
      const cell = normalized.cells?.[`${row.id}:${valueColumn.id}`] || {};
      const type = String(cell.type || row.type || valueColumn.type || "text").toLowerCase();
      const options = parseOptions(cell.options || row.options || valueColumn.options);
      return {
        id: String(row.id),
        label: row.label,
        type,
        options,
        required: Boolean(row.required || valueColumn.required || cell.required),
        description: row.description || valueColumn.description || "",
      };
    });
};
